<div class="hierarchy-filter" [ngClass]="{ dropdown: showFilterSubMenu }">
  <div [ngClass]="{ 'dropdown-menu is-block': showFilterSubMenu }">
    <div
      class="transaction-filter"
      [ngClass]="{
        'is-active dropdown multi-select-filter is-full-width': isOpen,
        'dropdown-height': isOpen && isDropdownHeight && isPreSelectedOrganizationNumber
      }"
      [class.is-hidden]="!isOpen && !isMainDropdownFilter && !isActive"
      (portalClickOutside)="closeFilter()"
    >
      <a
        class="is-hidden"
        (click)="openContent()"
        (keyup.enter)="openContent()"
        id="filter-organisation-detail"
      >
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
      </a>
      <div class="dropdown-trigger is-full-width rows">
        <div class="row is-full-width" *ngIf="!organizationGroup && !isSubMenuFilter">
          <button
            id="orgFilterButton"
            class="button is-chip is-full-width is-size-7-mobile"
            [class.is-applied]="selectedEntityCount > 0"
            [class.is-active]="isOpen"
            data-e2e="button-entity-filter"
            (click)="itemToggled.emit()"
            title="{{ title }}"
            type="button"
            [attr.aria-expanded]="isOpen"
          >
            <span>{{ title }}</span>

            <span class="icon">
              <i class="fas fa-chevron-down"></i>
            </span>
          </button>
        </div>
        <ng-container *ngIf="organizationGroup && entityIdListGroupOrganisation?.length">
          <div class="notification is-info">
            <div class="icon">
              <i class="far fa-info-circle fa-lg"></i>
            </div>
            <p i18n>
              When you select an organization, all its associated child organizations will
              automatically be included in the group.
            </p>
          </div>
        </ng-container>
        <ng-container *ngIf="organizationGroup && entityListGroupOrganisation?.length">
          <div *ngIf="!isParentSelected" class="box br-1 p-2 is-scroll">
            <ng-container *ngFor="let selectedEntity of entityListGroupOrganisation">
              <button
                type="button"
                class="button has-background-info-lighter has-text-dark has-not-border my-1 mr-2"
                [class.is-hidden]="selectedParentEntity?.entityUid === selectedEntity.entityUid"
                title="{{ selectedEntity.name }}"
              >
                <span
                  >{{ selectedEntity.name }}
                  {{ selectedEntity.count ? '(' + selectedEntity.count + ')' : '' }}</span
                >
                <span
                  class="icon is-size-7"
                  (click)="onRemoveSelectedOrganization(selectedEntity, true)"
                >
                  <i class="fas fa-times"></i>
                </span>
              </button>
            </ng-container>
          </div>
        </ng-container>

        <div class="input is-flex mb-5 mt-3" *ngIf="organizationGroup">
          <div
            class="selectedFeature-list"
            readonly="true"
            (click)="openContentOrganizationGroup()"
          ></div>
          <span class="input-icon is-size-7" [ngClass]="{ 'icon-rotate': isOpen }">
            <i class="fas fa-chevron-down"></i>
          </span>
        </div>
      </div>

      <div
        class="dropdown-menu organisations-filter"
        [ngClass]="{
          'mt-4': organizationGroup && !allPreSelectedEntities?.size,
          'dropdown-menu-max-wd': isOpen && isDropdownHeight
        }"
      >
        <div class="dropdown-content multi-select-filter p-0">
          <div class="is-flex is-justify-content-space-between pr-2">
            <div class="dropdown-item p-0 search-parameter-list">
              <a
                *ngIf="isSubMenuFilter && !displayFromFilter"
                tabindex="0"
                (click)="backToMenu()"
                (keyup.enter)="backToMenu()"
                data-e2e="button-back-to-men"
              >
                <span class="pl-3">
                  <span class="icon is-small">
                    <i class="fas fa-chevron-left fa-xs" aria-hidden="true"></i>
                  </span>
                  <span i18n>Back</span>
                </span>
              </a>
            </div>
          </div>

          <div class="dropdown-item px-2 py-1">
            <div class="field is-grouped is-flex-wrap-wrap">
              <div class="control mr-3 my-1" *ngFor="let searchParameter of searchParameterList">
                <label
                  class="radio"
                  attr.data-e2e="radio-search-parameter-label-{{ searchParameter.id }}"
                >
                  <input
                    [value]="searchParameter.id"
                    [(ngModel)]="searchParameterType"
                    type="radio"
                    attr.data-e2e="radio-search-parameter-{{ searchParameter.id }}"
                  />
                  <span>{{ searchParameter.text }}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="dropdown-item" *ngIf="allowDeleted">
            <div classs="field">
              <div class="control">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    [(ngModel)]="includeDeleted"
                    (ngModelChange)="onStatusChange()"
                  />
                  <span i18n>Include deleted organisations</span>
                </label>
              </div>
            </div>
          </div>

          <hr class="dropdown-divider" />
          <div class="dropdown-item px-2 py-1">
            <portal-search-filter-autocomplete-input
              [placeholder]="searchPlaceholder"
              [searchInputValue]="searchedText"
              [direction]="Directions.RIGHT"
              (search)="onSearch($event)"
            ></portal-search-filter-autocomplete-input>
          </div>

          <hr class="dropdown-divider" />

          <div
            *ngIf="limitExceeded"
            [ngClass]="{ 'pb-0': showSelectedEntities?.size }"
            class="dropdown-item has-text-danger"
            i18n
          >
            Select up to {{ selectLimit }} organisations
          </div>

          <ng-template #loader>
            <div class="dropdown-item has-text-truncate" *ngIf="loading$ | async; else notFound">
              <span class="has-text-truncate">
                <portal-spinner
                  [isHorizontal]="true"
                  [isSmall]="true"
                  text="Loading organisations..."
                  i18n-text
                ></portal-spinner>
              </span>
            </div>
          </ng-template>

          <ng-template #notFound>
            <div
              class="dropdown-item"
              *ngIf="!(loading$ | async) && !entities?.length && !isOrgExist"
            >
              {{ notFoundMessage }}
            </div>
          </ng-template>

          <div class="dropdown-item p-0" *ngIf="isOpen">
            <div class="hierarchical-wrapper">
              <div
                class="has-background-white-bis is-flex is-flex-direction-column py-0 px-2 is-overflow-hidden-x is-overflow-auto-y is-row-gap-1"
                [style.height.%]="entityFlex"
              >
                <div
                  *ngFor="let entity of selectedEntityList | keyvalue : compareFn"
                  title="{{ entity.value.path }}"
                >
                  <portal-search-filter-checkbox
                    #preSelectedEntities
                    [id]="entity.key"
                    [text]="getSelectedEntityText(entity.value.data)"
                    [selectedEntities]="selectedEntityList"
                    [shouldRemoveUnderscore]="false"
                    (removed)="deselectSelectedEntity(entity.value)"
                  ></portal-search-filter-checkbox>
                </div>
              </div>
              <div
                class="arrow-controls has-background-grey-lighter is-flex is-align-items-center is-justify-content-center is-column-gap-2"
              >
                <span
                  #upArrow
                  class="input-icon is-size-7"
                  [ngClass]="
                    isUpArrowDisabled ? 'has-text-grey-light disabled-arrow-icon' : 'is-clickable'
                  "
                  (click)="!isUpArrowDisabled && adjustHeights('up')"
                  [attr.tabindex]="isUpArrowDisabled ? -1 : 0"
                  (keydown.enter)="onArrowKey('up', $event)"
                  (keydown.space)="onArrowKey('up', $event)"
                  role="button"
                  [attr.aria-disabled]="isUpArrowDisabled"
                >
                  <i class="fas fa-chevron-up"></i>
                </span>
                <span
                  #downArrow
                  class="input-icon is-size-7"
                  [ngClass]="
                    isDownArrowDisabled ? 'has-text-grey-light disabled-arrow-icon' : 'is-clickable'
                  "
                  (click)="!isDownArrowDisabled && adjustHeights('down')"
                  [attr.tabindex]="isDownArrowDisabled ? -1 : 0"
                  (keydown.enter)="onArrowKey('down', $event)"
                  (keydown.space)="onArrowKey('down', $event)"
                  role="button"
                  [attr.aria-disabled]="isDownArrowDisabled"
                >
                  <i class="fas fa-chevron-down"></i>
                </span>
              </div>
              <!-- tree -->
              <div
                class="py-0 pl-2 pr-0 is-clickable is-overflow-hidden-x is-overflow-auto-y"
                [style.height.%]="treeFlex"
                role="tree"
                aria-label="Organization Hierarchy"
              >
                <tree-root
                  #tree
                  [options]="options"
                  [nodes]="entities"
                  [focused]="true"
                  [(state)]="treeState"
                  (deselect)="deselected($event)"
                  (select)="selected($event.node)"
                  (keydown.tab)="onKeyDownApply()"
                  (focusin)="onFocusIn($event, tree.treeModel)"
                  (focusout)="onFocusOut($event, tree.treeModel)"
                  *ngIf="!(loading$ | async) && isOrgExist; else loader"
                >
                  <ng-template
                    #treeNodeFullTemplate
                    let-node
                    let-index="index"
                    let-templates="templates"
                  >
                    <div
                      [class]="node.getClass()"
                      [class.tree-node]="true"
                      [class.tree-node-expanded]="node.isExpanded && node.hasChildren"
                      [class.tree-node-collapsed]="node.isCollapsed && node.hasChildren"
                      [class.tree-node-leaf]="node.isLeaf"
                      [class.tree-node-active]="node.isActive"
                      [class.tree-node-focused]="node.isFocused"
                      role="group"
                    >
                      <tree-node-drop-slot
                        *ngIf="index === 0"
                        [dropIndex]="node.index"
                        [node]="node.parent"
                      >
                      </tree-node-drop-slot>

                      <div class="node-wrapper is-align-items-start" role="treeitem" [attr.aria-level]="node.level" [attr.aria-expanded]="node.isExpanded ? 'true' : 'false'" [attr.aria-selected]="node.isSelected ? 'true' : 'false'">
                        <!-- Checkbox -->
                        <input
                          type="checkbox"
                          class="tree-node-checkbox mt-0_5"
                          [checked]="node.isSelected"
                          (change)="node.toggleSelected()"
                          (keydown.arrowRight)="node.expand()"
                          (keydown.arrowDown)="node.expand()"
                          (keydown.arrowLeft)="node.collapse()"
                          (keydown.arrowUp)="node.collapse()"
                          tabindex="0"
                          [attr.aria-label]="'Select ' + (node.data?.name || 'entity')"
                        />

                        <!-- Expander: make it keyboard accessible -->
                        <span
                          class="toggle-children-wrapper pt-0 pb-0"
                          [class.toggle-children-wrapper-collapsed]="node.isCollapsed"
                          [class.toggle-children-wrapper-expanded]="node.isExpanded"
                          role="button"
                          aria-label="Toggle children"
                          (click)="node.toggleExpanded()"
                          (keydown.enter)="node.toggleExpanded(); $event.preventDefault()"
                          (keydown.space)="node.toggleExpanded(); $event.preventDefault()"
                          (keydown.arrowRight)="node.expand()"
                          (keydown.arrowDown)="node.expand()"
                          (keydown.arrowLeft)="node.collapse()"
                          (keydown.arrowUp)="node.collapse()"
                        >
                          <span
                            *ngIf="node.data?.count"
                            class="toggle-children ml-3"
                            tabindex="0"
                          ></span>
                        </span>

                        <!-- Label / content -->
                        <div
                          class="node-content-wrapper width-full"
                          [ngClass]="{ 'ml-3': !node.data?.count }"
                        >
                          <div
                            [ngClass]="{
                              'is-flex is-flex-direction-row is-justify-content-space-between': !(
                                isDeviceMobile$ | async
                              )
                            }"
                          >
                            <div class="is-word-wrap is-flex is-flex-direction-column">
                              <div>
                                <span class="is-size-6">{{ node.data?.name }}</span>
                                <span class="has-text-grey-darker" *ngIf="node.data?.count">
                                  ({{ node.data?.count }})</span
                                >
                              </div>
                              <div
                                class="white-space-no-wrap my-1"
                                *ngIf="isEntityTypeVisible(node, isDeviceMobile$ | async)"
                              >
                                <span
                                  class="tag"
                                  [ngClass]="node.level === 1 ? 'is-special' : 'is-actionable'"
                                  >{{ node.data?.entityType | readableEntityType }}</span
                                >
                              </div>
                              <div
                                *ngIf="isFriendlyNameFeatureActive && node.data?.friendlyName"
                                class="is-size-7"
                              >
                                {{ node.data.friendlyName }}
                              </div>
                              <div>
                                <span
                                  class="is-size-7 text-ellipsis"
                                  *ngIf="node.data?.path"
                                  [attr.title]="node.data.path"
                                >
                                  {{ node.data.path | middleEllipsisPath }}
                                </span>
                              </div>
                            </div>
                            <div
                              class="white-space-no-wrap mt-0_5"
                              *ngIf="isEntityTypeVisible(node, !(isDeviceMobile$ | async))"
                            >
                              <span
                                class="tag"
                                [ngClass]="node.level === 1 ? 'is-special' : 'is-actionable'"
                              >
                                {{ node.data?.entityType | readableEntityType }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <tree-node-children
                        [node]="node"
                        [templates]="templates"
                      ></tree-node-children>
                      <a
                        *ngIf="
                          node.isExpanded &&
                          node?.children?.length &&
                          node?.children?.length < node?.data?.count &&
                          node?.data?.entityUid !== currentRootEntity
                        "
                      >
                        <span
                          id="orgLoadMoreButton"
                          class="ml-5"
                          *ngIf="!(loadingMore$ | async)"
                          (click)="loadMore(node)"
                          i18n
                        >
                          Load more
                        </span>
                      </a>
                      <div class="ml-5" *ngIf="(loadingMore$ | async) === node.id">
                        <div class="load-more-container">
                          <div class="spinner-container is-horizontal is-justify-content-start">
                            <div class="spinner is-small" role="status" aria-live="assertive"></div>
                            <div i18n class="pl-1">Loading...</div>
                          </div>
                        </div>
                      </div>

                      <tree-node-drop-slot
                        [dropIndex]="node.index + 1"
                        [node]="node.parent"
                      ></tree-node-drop-slot>
                    </div>
                  </ng-template>

                  <ng-template #treeNodeTemplate let-node let-index="index">
                    <div
                      class="is-flex is-flex-direction-column is-word-wrap"
                      (click)="toggleCheckbox(node)"
                    >
                      <div>
                        <span class="is-size-6 is-inline-block">{{ node.data?.name }}</span>
                        <span class="has-text-grey-darker" *ngIf="node.data?.count">
                          ({{ node.data?.count }})
                        </span>
                      </div>
                      <span class="is-size-7" *ngIf="node.data?.path">{{ node.data?.path }}</span>
                    </div>
                  </ng-template>
                </tree-root>
              </div>
            <span class="has-text-truncate" *ngIf="loadingNewPortion$ | async">
              <portal-spinner [isSmall]="true"></portal-spinner>
            </span>
          </div>
          <hr class="dropdown-divider" />
          <div
            class="dropdown-item py-1 px-2 is-flex is-justify-content-space-between"
            *ngIf="isOrgExist"
          >
            <button
              id="orgClearButton"
              class="button is-outlined"
              data-e2e="button-clear-filter"
              i18n
              (click)="clearFilter()"
              (keydown.enter)="clearFilter()"
              type="button"
              title="Clear"
              i18n-title
            >
              Clear
            </button>
            <button
              id="orgApplyButton"
              class="button is-primary"
              data-e2e="button-filter"
              i18n
              [disabled]="disabledApply"
              (click)="onFilterApplied()"
              (keyup.enter)="onFilterApplied()"
              title="Add"
              i18n-title
              type="button"
              tabindex="0"
              #applyButton
            >
              {{ addButtonLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
